export default __webpack_public_path__ + "static/media/Hair_2_M_C1.210485b9.svg";